// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  ScoreCard,
  GameTypeTab,
  StatsGraph,
  AllGametypeTab
}                         from '../../../components';

import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import { Multiselect } from 'react-widgets'
import Modal from 'react-modal';
import styles                 from './style';
import { Spinner } from 'react-activity';
import ReactTable from "react-table"; 
import moment from "moment";
import DatePicker from 'react-datepicker';
import Card from '../../../components/card/Card';
import styled from 'styled-components';
import ActiveCustomers from '../../partner/activeCustomers';
import CircularProgress from 'material-ui/CircularProgress';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const customStyles = {
  content : {
    top                   : '20%',
    left                  : '20%',
    right                 : '20%',
    bottom                : '20%',  
  },
    overlay: {
     background: "grey",
     overflow: 'hidden',
     position: 'fixed',
     zIndex   : '15'
   }
};

class TargetDetails extends PureComponent {  

  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      customer_data: [],
      selected_venue:'a2d3c8eb-ae59-4c8a-830d-d85dbf7b3944',
      selected_target_id:0,
      page: 1,
      pages: 10,
      customer_headers: [],
      comment:'',
      active_cust_count: 0,
      customer_details: true,
      paid_customer: false,
      excel_data:[],
      venue_list: [],
      report_no:312,
      report_name:'All Active Customers'

    };
    this.handleSelection = this.handleSelection.bind(this);
    this.onCustomerClick = this.onCustomerClick.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onChange = this.onChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.postSaveChanges = this.postSaveChanges.bind(this);

  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('PartnerDashboard');
  }

   handleChange(event){
      var value = event.target.value
      var name = event.target.name
      console.log('handleChange..')
      console.log(value)
      console.log(name)
      this.setState({comment:value})
      
    }

  closeModal() {
    this.setState({popup: false});
  }

  componentDidMount() {
    this.getVenueList()
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('PartnerDashboard');
  }

   postSaveChanges(props) {
    const url = `${getLocationOrigin()}/eagleeye/update_target_comment/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                                        'selected_target_id': this.state.selected_target_id,
                                        'comment':this.state.comment

                                      });
    console.log('Going to fetch');
    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then((response) => {
      alert(response.message);
    })
    .catch(error => {
    console.log(error);
    alert(error.message);
                });
  }

onSelect(optionsList, selectedItem) {
      console.log(optionsList)
      console.log(selectedItem)
     
      var name = optionsList.name ;
      this.setState({ selected_venue: optionsList.id,selected_name: name });
    }

onChange(event){
  console.log('eveee')
  console.log(event.target.name)
  console.log(event.target.value)
    const name = event.target.name;
    this.setState({selected_venue: event.target.value},()=>{this.getCustomers()});
     
    }

  getVenueList(){
      const url = `${getLocationOrigin()}/court/get_venues/?type=hot_leads`;
       const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => 
          this.setState({venue_list: data.results}))
         .catch(error => error);
    }

onCustomerClick(){
    this.setState({customer_details:true,paid_customer:false})
  }

  onPaidCustomerClick(){
    this.setState({paid_customer:true,customer_details:false})
  }



  getCustomers() {
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=${this.state.report_no}&venue_id=${this.state.selected_venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({customer_data:data.data,customer_headers:data.headers,excel_data:data.excel_data})
           // alert("fix");
       }).catch(error => error);
  }

  handleSelection(event){
    const name = event.target.name;
    if(name == 'revenue'){
      this.setState({report_no:312,report_name:'Monthly Revenue'},()=>{this.getCustomers()});
    }
    else{
      this.setState({report_no:3121,report_name:'Monthly Collection'},()=>{this.getCustomers()});
    }
  }

  render() {      
      console.log('calling render*******')
      console.log(this.state.selected_venue)
      var report = this.state.report_no
      var headings_list = []
        if(this.state.customer_headers.length > 0){
          var tab_index = []
          for (var i = 0; i < this.state.customer_headers.length; i++) {
            if(this.state.customer_headers[i].indexOf("_hidden") == -1){
              headings_list.push(this.state.customer_headers[i]);
              tab_index.push(i);
            }
          }
        }
        if(this.state.customer_data.length == 0 && headings_list.length == 0){
          this.getCustomers()
        } 


      if(report == 312){    
        headings_list = ["Month","Revenue","Target"];
      }
      else{
        headings_list = ["Month","Collection","Target"];
      }
      headings_list.push("Actions");
      var rows = this.state.customer_data.map(function(lead,index){
        var row = { ...lead }
        if(report == 312){ 
          var headers = ["Month","Revenue","Target"];
          row["Revenue"] = row[1]
        }
        else{
          var headers = ["Month","Collection","Target"];
          row["Collection"] = row[1]
        }
        
        row["Month"] = row[0]
        
        row["Target"] = row[2]
        if(row[4] != ''){
          row["Actions"] = row[4]+' - '+'<button style = "color: black; background-color:#EEA083;</style>" >' +'Edit Comment' + '</button>';
        }
        else{
          row["Actions"] = '<button style = "color: black; background-color:#EEA083;</style>" >' +'Add Comment' + '</button>';
        }
        return row
 

      });

      var csvData = [];
      var excel_rows = this.state.excel_data.map(function(lead,index){
        var row = { ...lead }
        if(report == 312){ 
          var headers = ["Month","Revenue","Target"];
          var csvHeader = ["Month","Revenue","Target","Comment"];
        }
        else{
          var headers = ["Month","Collection","Target"];
          var csvHeader = ["Month","Collection","Target","Comment"];
        }
        csvData[0] = headers;
        
        var j;
        var csv = []
        console.log(row)
        for(j=0;j<(csvHeader.length)+1;j++){
          if (j != '3'){
            csv.push(row[j]);
          }
            
        }
        csvData.push(csv);
        return row
 

      });

      console.log('headings..')
      console.log(headings_list)
      
    const headings = headings_list.map(function(element,index){
      var heading = {};
      heading["name"] = element;
      heading["accessor"] = element;//For react-table
      heading["displayName"] = element.charAt(0).toUpperCase() + element.slice(1);
      heading["Header"] = element.charAt(0).toUpperCase() + element.slice(1); //For react-table
      heading["sortable"] = true;
      heading["minWidth"] = 60;
      heading["inputFilterable"] = true;
      heading["visible"] = (element.indexOf("_hidden") == -1);
      heading["show"] = (element.indexOf("_hidden") == -1);
      heading["render"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;
      heading["Cell"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;// Custom cell components for react-table
      return heading;
    });   
       
      const {
        statsTable, scoreCard,statsGraph
      } = this.props;
      if(report == 312){ 
        var csvHeader = ["Month","Revenue","Target","Comment"];
      }
      else{
        var csvHeader = ["Month","Collection","Target","Comment"];
      }
       csvData[0] =  ['']
       
      if(this.state.customer_details.length>0){
        var rowCount = this.state.customer_details.length
      }
      else 
        var rowCount = 0
      
    return( 

        <div className="col-md-12 table-bordered" style={styles.table} style={{marginLeft: '8px'}}>
          <div style={{fontSize:'96%',marginBottom:'1%'}}>
              <button style={{marginRight:'1%',width:'24%',padding:'0.5% 0.5%',fontWeight:'bold',backgroundColor:this.state.report_no == 312 ? '#4daa0b':'#d7d9db'}} name='revenue' onClick={this.handleSelection}>Revenue</button>
              <button style={{marginRight:'1%',width:'24%',padding:'0.5% 0.5%',fontWeight:'bold',backgroundColor:this.state.report_no == 3121 ? '#4daa0b':'#d7d9db'}} name='collection' onClick={this.handleSelection}>Collection</button>
          </div>
          <div style={{width:'100%',marginBottom:'2%'}}>

            <div style={{width:'30%'}} className="col-md-12">
              <div style={{width:'50%'}} className="col-md-6">
                Venue
              </div>
              <select name="venue" className="col-md-6" style={{width:'50%'}} value={this.state.selected_venue}
                onChange={this.onChange} >
                {
                  this.state.venue_list.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.value}</option>
                  ))
                }
              </select>
            </div>
            <div style={{float:'right'}}>
              <ReactHTMLTableToExcel
                        id="btn btn-lg"
                        className="download-table-xls-button"
                        table="table-to"
                        filename="Revenue/Collection data"
                        sheet="Revenue/Collection data"
                        buttonText="Download "/>
            </div>

          </div>

          {this.state.loading === true || this.state.selected_venue == 0 ?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}><CircularProgress /></div>
              </div>
               
          :

            <div style={{margin:10,marginTop:'7%'}}> 

              <div className="row new-table" >    
                <div className="row col-md-12" style={styles.table} style={{marginLeft: '3px'}}>
                  <ReactTable
                    data={rows}
                    rowsText={rowCount.toString()}  //Workaround to store the total rows.
                    columns={headings}
                    showPagination={true}
                    showPaginationTop={true}
                    defaultPageSize={100}
                    minRows={0}
                    style={{backgroundColor:'#9370DB',marginRight: '6px'}}
                    filterable={false}
                    orderBy={true}
                    defaultFilterMethod= {(filter, row, column) => {
                      const id = filter.pivotId || filter.id
                      return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                    }}
                    manual  
                    pages = {this.state.pages}  
                    page = {this.state.page-1}
                    pageSizeOptions = {[100]}
                    showPageSizeOptions = {false}
                    manualPagination={true}
                    sorted={this.state.sortOption}
                    onPageChange={page => {
                       this.setState({page: page+1}, () => this.findHotLeads(this.state.location) )
                    }}
                  

                    onSortedChange = { sortOption => {
                       this.setState({sortOption:sortOption,  sortColumn: sortOption[0].id,sortOrder:sortOption[0].desc}, () => this.findHotLeads(this.state.location) )
                       

                    }}                 

                    getTrProps={(state, rowinfo, column) => {
                      var bgcolor = '#dcdcdc';
                      if (rowinfo!=undefined && rowinfo.row.hasOwnProperty("style_hidden")) {
                          var row_style = rowinfo.row["style_hidden"]
                          if(row_style!=null && row_style.indexOf('row-danger') != -1){
                            bgcolor = '#FFC8B8';
                          }else if(row_style!=null && row_style.indexOf('row-warning') != -1){
                            bgcolor = '#FFE699';
                          }
                      }              
                      return {
                        style: {
                          background: 'white',height:'50px'
                        }
                        
                        
                      };
                    }}

                    getTdProps={(state, rowInfo, column, instance) => {

                      return {

                        
                          onClick: (e, handleOriginal) => {
                              if(column.displayName === 'Actions'){
                                this.setState({selected_target_id:rowInfo.row._original[3],popup:true,comment:rowInfo.row._original[4]})
                              }

                              // IMPORTANT! React-Table uses onClick internally to trigger
                              // events like expanding SubComponents and pivots.
                              // By default a custom 'onClick' handler will override this functionality.
                              // If you want to fire the original onClick handler, call the
                              // 'handleOriginal' function.
                              if (handleOriginal) {
                                handleOriginal()
                            }
                          }

                      }
                    }}                   

                    >



                  {/*{
                    //To show the record count on top  
                    (state, makeTable, instance) => {

                      let recordsInfoText = "";

                      const { filtered, pageRows, pageSize, sortedData, page } = state;

                      if (sortedData && sortedData.length > 0) {
                        let isFiltered = filtered.length > 0;

                        let totalRecords = state.rowsText;

                        let recordsCountFrom = page * pageSize + 1;

                        let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                        if (isFiltered){
                          recordsInfoText = `${totalRecords} filtered records`;
                        }
                        else {
                          recordsInfoText = `${totalRecords} records`;
                        }
                      } else {
                          recordsInfoText = "No records";
                        }
                      return (
                        <div className="main-grid">
                          <div className="above-table text-right">
                            <div className="col-sm-12 records-info">
                              <span className="">{recordsInfoText}</span>
                            </div>
                          </div>
                          {makeTable()}
                          
                        </div>

                      );
                    }
                  }*/}
            </ReactTable>
                </div>
              </div>
            </div>
          }

          <table id="table-to" style={{fontSize:'0%',opacity:'0'}}>
              <tr> 
                {csvHeader.map((head)=>
                  <th>{head}</th>)}
              </tr>
                {csvData.map((data)=>
                  <tr>
                    { data.map((each)=>
                      <td >{each}</td>
                      )
                    }
                  </tr>
                  )}
                
            </table>

          { this.state.popup ?
            <div >
             <Modal 
                isOpen={this.state.popup}
                onRequestClose={this.closeModal}
                style={customStyles}

              >
                
                <div style={{textAlign:'center'}}>Comment</div>
                <input style={{padding: '3px ',color: 'black',width:'100%',height:'70%'}} name="comment" value={this.state.comment} onChange={this.handleChange} />                
              <div style={{textAlign:'center'}}><button className ="btn" onClick={this.closeModal} style={{color:'red',textAlign:'center'}}>Close</button>
              <button className ="btn" onClick={this.postSaveChanges} style={{color:'red',textAlign:'center'}}>Submit</button></div>
              </Modal>
            </div>
            :
            ""
            
          }


        </div>       
      );
    }
  }

export default TargetDetails;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/targetDetails/TargetDetails.js